module.exports = __webpack_public_path__ + "static/media/down-arrow-green.f0b44ff5.svg";